export default __webpack_public_path__ + "static/media/relative-medium-pro.8773b89f.eot";